module.exports = __webpack_public_path__ + "img/slide-3__sm.ab4790df.jpg";